import { Box, styled, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectPrompts, setPage } from '../../redux/reducers/promptReducer';
import { AppDispatch } from '../../redux/store';
import { StyledPagination } from '../../theme/CustomComponents';
import { Prompt } from '../../Types/prompt';
import PromptCard from './PromptCard';

interface PromptsGridProps {
  isAIAppStore: boolean;
  newlyCreatedId: string | null;
  clearNewlyCreated: () => void;
}

const CardContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  width: '100%',
});

const PromptsGrid: React.FC<PromptsGridProps> = ({
  isAIAppStore,
  newlyCreatedId,
  clearNewlyCreated,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    prompts,
    page,
    totalPages,
    publishedOnly,
    selectedLabels: selectedTags,
    searchQuery,
  } = useSelector(selectPrompts);

  const handlePageChange = useCallback(
    (_e: React.ChangeEvent<unknown>, value: number) => {
      dispatch(setPage(value));
    },
    [dispatch]
  );

  return (
    <Box display="flex" flexDirection="column" width="100%">
      {prompts.length === 0 ? (
        selectedTags.length === 0 && searchQuery === '' ? (
          <Typography>No {isAIAppStore ? 'apps' : 'prompts'}, create one!</Typography>
        ) : (
          <Typography>No {isAIAppStore ? 'apps' : 'prompts'} found for given filters</Typography>
        )
      ) : (
        <CardContainer>
          {prompts.map((prompt: Prompt) => (
            <PromptCard
              key={prompt.id}
              prompt={prompt}
              publishedOnly={publishedOnly}
              autoScroll={prompt.id === newlyCreatedId}
              onScrolled={clearNewlyCreated}
              isAIAppStore={isAIAppStore}
            />
          ))}
        </CardContainer>
      )}
      <Box sx={{ mt: 2 }}>
        <StyledPagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          size="small"
          sx={{ justifyContent: 'center', display: 'flex' }}
        />
      </Box>
    </Box>
  );
};

export default PromptsGrid;
